import { Link, Text } from '@spotify-internal/encore-web';

import {
  CODING_SESSION_APPLICATION_FALLBACKS,
  type CodingSessionApplication,
} from './buildCodingSessionLaunchUrl';

export const CodingSessionLaunchFallback = ({
  application,
}: {
  application: CodingSessionApplication;
}) => {
  const { label, url } = CODING_SESSION_APPLICATION_FALLBACKS[application];

  return (
    <Text as="p" variant="bodySmall">
      {application} didn’t open?{' '}
      <Link href={url} target="_blank" rel="noopener noreferrer" data-track-source-anchor="1a2a90ed14;coding-session-launch-fallback-link">
        {label}
      </Link>{' '}
      and try again.
    </Text>
  );
};
